import { MessageableFactory, SignalableFactory } from '@locumsnest/core/src';

export const messageableFactory = MessageableFactory.forFeature<'MessagingUI'>('MessagingUI');
export const signalableFactory = SignalableFactory.forFeature<'MessagingUI'>('MessagingUI');
